module.exports = __webpack_public_path__ + "static/img/BR.a8d98a1a.png";